import type { RouteRecordRaw } from 'vue-router';

const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const OtpVerifyPhone = () => import('../pages/OtpVerifyPhone/index.vue');

export const otpRoutes: Array<RouteRecordRaw> = [
  {
    path: '/verify-phone',
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: 'verify-phone-otp',
        component: OtpVerifyPhone,
      },
    ],
  },
];
